<script>
import {mapActions} from "vuex";

export default {
  name: 'UpdateHandler',
  data () {
    return {
      isChanged: false,
      normalizedFrequencyMinutes: 1,
      autoUpdateTimer: null,
      autoUpdateCountdown: 0,
      autoUpdateDelay:120,
    }
  },
  created() {
    //  定期処理
    const self = this
    const sec = 1000 * 60 * this.normalizedFrequencyMinutes

    setInterval(function () {
      self.checkUpdate().then((content) => {
        // content = 'changed'
        if (content === 'reload') {
          self.reloadButtonClickEvent()
        } else if (content === 'changed') {
          self.isChanged = true;
          self.startAutoUpdateCountdown();
        }
      })
    }, sec)

  },
  methods: {
    ...mapActions('UpdateChecker', {
      checkUpdate: 'index',
    }),
    reloadButtonClickEvent () {
      if (this.autoUpdateTimer) {
        clearInterval(this.autoUpdateTimer)
      }
      window.location.reload(true)
    },
    closeButtonClickEvent() {
      if (this.autoUpdateTimer) {
        clearInterval(this.autoUpdateTimer)
      }
      this.isChanged = false
    },
    /**
     * 自動更新タイマー
     */
    async startAutoUpdateCountdown() {
      // タイマー設定済であればいクリア
      if (this.autoUpdateTimer) {
        clearInterval(this.autoUpdateTimer)
      }

      this.autoUpdateCountdown = this.autoUpdateDelay

      this.autoUpdateTimer = setInterval(() => {
        this.autoUpdateCountdown--

        if (this.autoUpdateCountdown <= 0) {
          clearInterval(this.autoUpdateTimer)
          this.autoUpdateTimer = null
          this.reloadButtonClickEvent()
        }
      }, 1000)
    }
  },
}
</script>

<template>
  <div v-if="isChanged" class="update-toast" role="alert">
    <div class="update-content">
      <div class="update-icon">
        <v-icon color="primary" large>mdi-update</v-icon>
      </div>
      <div class="update-message">
        <h3 class="update-title">アプリの更新があります</h3>
        <p class="update-description">
          新しいバージョンが利用可能です。
          <br/>
          <span v-if="autoUpdateCountdown > 0">
            {{ autoUpdateCountdown }}秒後に自動的に更新されます。
          </span>
        </p>
      </div>
    </div>

    <div class="update-actions">
      <v-btn
        text
        style="color: #01579B;font-weight: 700;"
        @click="reloadButtonClickEvent"
        class="update-now-btn"
      >
        今すぐ更新
      </v-btn>

      <v-btn
        text
        style="font-weight: 700;"
        @click="closeButtonClickEvent"
        class="update-later-btn"
      >
        後で
      </v-btn>
    </div>
  </div>
</template>

<style scoped lang="scss">
.update-toast {
  position: fixed;
  right: 0;
  bottom: calc(4rem);
  margin: 16px;
  padding: 16px;
  border-radius: 12px;
  z-index: 9999;
  background-color: white;
  max-width: 90%;
  width: 380px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  //animation: slide-in 0.3s ease-out;


  outline-width: 1px;
  outline-offset: 0;
  outline-color: rgba(0, 130, 206, 0.75);
  outline-style: solid;
  animation: animateOutline 4s ease infinite;
}

.update-content {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.update-message {
  flex: 1;
}

.update-icon {
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(0, 112, 179, 0.1);
}

.update-title {
  font-size: 1rem;
  font-weight: 600;
  margin: 0 0 4px 0;
}

.update-description {
  font-size: 0.9rem;
  margin: 0;
  color: rgba(0, 0, 0, 0.7);
}

.update-error {
  color: #f44336;
  font-size: 0.85rem;
  margin: 8px 0 0 0;
}

.update-actions {
  display: flex;
  justify-content: flex-end;
}

.update-now-btn {
  margin-right: 8px;
}

//@keyframes slide-in {
//  from {
//    transform: translateY(20px);
//    opacity: 0;
//  }
//  to {
//    transform: translateY(0);
//    opacity: 1;
//  }
//}

@keyframes animateOutline {
  0% {
    outline-width: 1px;
    outline-offset: 0;
    outline-color: rgba(0, 130, 206, 0);
  }

  10% {
    outline-color: rgba(0, 130, 206, 0.75);
  }

  /* The animation finishes at 50% */
  50% {
    outline-width: 7px;
    outline-offset: 4px;
    outline-color: rgba(0, 130, 206, 0);
  }

  100% {
    outline-width: 7px;
    outline-offset: 4px;
    outline-color: rgba(102, 102, 102, 0);
  }
}

@media (max-width: 600px) {
  .update-toast {
    width: calc(100% - 32px);
    bottom: calc(4rem + env(safe-area-inset-bottom));
    margin: 0 16px 16px 16px;
  }
}
</style>
